module.exports = __webpack_public_path__ + "static/img/stone.eb186a90.jpeg";